import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { getRootStore } from "@/stores/RootStore";
import { observer } from "mobx-react-lite";
import { canEditDictionaries } from "@/utils/permissions";
import { canDeleteFromDictionaries } from "@/utils/permissions";
import { message, Modal, Skeleton, Card, Button, Flex } from "antd";
import styles from "@/styles/ChargingStationModelPage.module.less";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import { ChargingStationModelForm } from "@/components/ChargingStationModelForm/ChargingStationModelForm";
export const ChargingStationModelPage = observer(() => {
    const navigate = useNavigate();
    const { modelId } = useParams();
    const { singleChargingStationModelStore: store, authStore: { userRole }, } = getRootStore();
    const { model, loading, manufacturerSelectStore } = store;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        store.init(modelId);
        return () => {
            store.clearModelData();
        };
    }, [modelId]);
    const handleBack = () => {
        navigate("/charging-station-models");
    };
    const handleSave = async (values) => {
        const isNewModel = !model;
        store.saveModel(values).then((savedModel) => {
            if (savedModel) {
                if (isNewModel) {
                    message.success("Модель зарядной станции успешно создана");
                    navigate(`/charging-station-models/${savedModel.id}`);
                }
                else {
                    message.success("Модель зарядной станции успешно обновлена");
                }
            }
        });
    };
    const handleDeleteModel = () => {
        if (!model)
            return;
        Modal.confirm({
            title: "Удаление модели зарядной станции",
            content: "Вы уверены, что хотите удалить эту модель?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: async () => {
                await store.deleteModel(model.id);
                message.success("Модель зарядной станции успешно удалена");
                handleBack();
            },
        });
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return (_jsxs(Flex, { vertical: true, gap: "large", className: styles.container, children: [_jsx("div", { className: styles.backButtonContainer, children: _jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBack, type: "text", className: styles.backButton, children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443" }) }), _jsx(ChargingStationModelForm, { model: model, loading: loading, onSubmit: handleSave, onCancel: handleBack, disabled: !canEdit, extraButtons: _jsx(_Fragment, { children: canDelete && model && (_jsx(Button, { danger: true, icon: _jsx(DeleteOutlined, {}), onClick: handleDeleteModel, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043C\u043E\u0434\u0435\u043B\u044C" })) }), selectStores: {
                    manufacturerSelectStore,
                } })] }));
});
export default ChargingStationModelPage;
